module.exports = __webpack_public_path__ + "2b0ed7a0a338ecef2716321d18125972.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-58.cur
// module id = 466
// module chunks = 0